// FORGED Ed Systems — DEPLOY002 — v0.2.0 — SignInPage.tsx
// Last touched: 2026-05-19
//
// Email + password sign-in via Supabase Auth.

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "./supabaseClient";

export default function SignInPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErrorMsg(null);
    setSubmitting(true);

    const res = await supabase.auth.signInWithPassword({ email, password });
    setSubmitting(false);

    if (res.error) {
      setErrorMsg(res.error.message);
      return;
    }

    navigate("/dashboard");
  }

  return (
    <main className="container">
      <header className="brand-header">
        <h1>Sign in</h1>
        <p className="tagline">Welcome back.</p>
      </header>

      <form onSubmit={handleSubmit} className="form-stack" style={{ maxWidth: "440px" }}>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {errorMsg && <div className="error-banner">{errorMsg}</div>}

        <button type="submit" className="cta primary" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>

       <p style={{ color: "var(--color-text-muted)" }}>
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>

        <p style={{ color: "var(--color-text-muted)" }}>
          New to forgedsight? <Link to="/register">Create an account</Link>
        </p>
      </form>
    </main>
  );
}
